import { Table } from "@tanstack/react-table";
import classNames from "classnames";
import { NoDataComponent } from "../no-data-component/no-data-component";
import { TableHeaderColumn } from "../table-header-column/table-header-column";
import { IdwTableRow } from "./idw-table-row/idw-table-row";
import styles from "./idw-table.less";

type IdwTableProps<T> = {
    id: string;
    useTableResult: Table<T>;
    renderExpandedComponent?: (row: any) => React.ReactNode;
    renderTableRowHoverComponent?: (props: any, row: any) => React.ReactNode;
    onClickTableRow?: (row: any) => void;
    headerColumnKeyPrefix: string;
    className?: string;
};

export const IdwTable = <T extends object>(props: IdwTableProps<T>) => {

    const {
        id,
        useTableResult,
        headerColumnKeyPrefix,
        renderExpandedComponent,
        renderTableRowHoverComponent,
        onClickTableRow,
        className
    } = props;

    const tableRows = useTableResult.getRowModel().rows;
    const headers = useTableResult.getFlatHeaders();

    return (
        <div className={styles.idwTableContainer}>
            <table id={id} className={classNames(styles.idwTable, className)}>
                <thead>
                    {useTableResult.getHeaderGroups().map((headerGroup, index) => (
                        <tr key={`${headerColumnKeyPrefix}-tr-${index}`}>
                            {headerGroup.headers.map((header, index) => (
                                <TableHeaderColumn
                                    key={`${headerColumnKeyPrefix}-th-${index}`}
                                    id={`${headerColumnKeyPrefix}-th-${header.id}`}
                                    header={header}
                                    colSpan={header.colSpan || 1}
                                />
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody>
                    {tableRows.map((row) => (
                        <IdwTableRow
                            key={row.id}
                            row={row}
                            headers={headers}
                            onClickTableRow={onClickTableRow}
                            renderExpandedComponent={renderExpandedComponent}
                            renderTableRowHoverComponent={renderTableRowHoverComponent}
                        />
                    ))}
                </tbody>
            </table>
            {tableRows.length === 0 && (
                <NoDataComponent />
            )}
        </div>
    );
};